import Vue from 'vue'

var message = {

	progressResult: {
	    'requiredResult' : '結果を入力してください。',
	    'requiredSelectReason' : '不合格の場合、結果理由を選択してください。',
	    'requiredInputReason' : '結果理由を入力してください。',
	    'requiredInputCharge' : '担当者名を入力してください。',
	    'requiredInputEmail' : 'メールアドレスを入力してください。',
		'notValidInputEmail' : 'メールアドレスが不正です。',
		'requiredInputFreeComment' : '結果理由に「その他」を選んだ場合、フリーコメント欄に理由を入力してください。',
		'moreThan200WordFreeComment' : 'フリーコメントは200文字以内で入力してください。',
		'requiredInputContent' : '問い合わせ種別を選択した場合、問い合わせ内容を入力してください。',
		'requiredInputInterviewType' : '合格の場合、次回面接方法を入力してください。',
		'requiredInputRecruitMeasure' : '合格の場合、採用への温度感を入力してください。',
		'requiredInputRecruitComment' : '合格の場合、評価点・ご懸念点を入力してください。',
        'success': '送信しました。'
	},

	afterEnteringSurvey: {
        'requiredQuestion1' : '■1は必須項目です。',
        'requiredQuestion2' : '■2は必須項目です。',
        'requiredQuestion3' : '■3は必須項目です。',
        'requiredName' : 'お名前を入力してください。'
	},

	cSAndRecruit: {
        'requiredQuestion1' : '担当コンサルタントの満足度を選択してください。',
        'requiredQuestion2' : '担当コンサルタントの理解度を選択してください。',
		'requiredQuestion3' : '担当コンサルタントの変更希望を選択してください。',
		'requiredQuestion4' : '弊社のサービス紹介の意向を選択してください。',
		'requiredQuestion5' : '理由を選択してください。',
		'requiredQuestion5_other' : '「その他」を選択された場合は理由も入力してください。',
		'requiredQuestion6' : '採用予定の人数を入力してください。',
		'requiredQuestion6_Progress' : '今年度の採用計画の進捗状況を選択してください。',
		'overLimitQuestion6Other': '2000文字以内で入力してください。',
		'overLimitQuestionHighClassNeedsOther': '2000文字以内で入力してください。',
		'overLimitQuestion7': '1000文字以内で入力してください。',
  		'requiredQuestion8_recruitment_staff': '採用担当の人数を入力してください。',
  		'requiredQuestion8_recruitment_assistant': 'その他アシスタントの人数を入力してください。',
		'requiredQuestion8_post' : '役職を入力してください。',
		'requiredQuestion8_name' : 'お名前を入力してください。',
		'messQuestionAllComponent' : '入力エラーになっている項目があります。',
		'requiredQuestionKansai' : '■8は必須項目です。',
		'requiredQuestionKansai2' : '■8は職種と人数を入力してください。',
		'requiredQuestionAgent' : '最も採用実績の多い会社を選択してください。',
		'requiredQuestionAgentOther' : '「その他」を選択された場合はエージェント名も入力してください。',
		'requiredQuestionHighClassNeeds' : 'ハイクラス人材の採用ニーズを選択してください。',
		'success': '送信しました。'
	},

	kutikomiReview: {
		'invalidUrl': '不正なURLです',
		'clientReviewIsExpired': '口コミ投稿の期間が過ぎています。',
		'alreadyRecievedKutikomiReview': '口コミ投稿は受領済みです。',
		'alreadyRecievedEntryClient': '選択された企業の口コミは、受領済みです。',
		'RecievedKutikomiReviewIsUnderReview': '受領した口コミ投稿を審査中です。審査完了後に再度投稿をお願いします。',
		'requiredName': 'お名前（ニックネーム可）を入力してください。',
		'requiredEmail': 'メールアドレスを入力してください。',
		'requiredClientName': 'レポート対象企業を選択するか、「企業が見つからない場合はこちら」より入力してください。',
		'requiredEmpTypeId': '雇用形態は必須です。',
		'requiredEnrollmentStatus': '在籍状況は必須です。',
		'requiredTypeOfJoinTheCompany': '入社形態は必須です。',
		'requiredWkPeriodSDateYear': '入社年は必須です。',
		'requiredWkPeriodSDateMonth': '入社月は必須です。',
		'requiredWkPeriodEDateYear': '退職年は必須です。',
		'requiredWkPeriodEDateMonth': '退職月は必須です。',
		'requiredOcupCtg': '職種は必須です。',
		'requiredDepartment': '事業部・部門は必須です。',
		'requiredPost': '役職は必須です。',
		'comparisonWkPeriodDate': '退職年月は入社年月以降を指定してください。',
		'required': '必須項目になります。選択してください。',
		'requiredConsent': '同意が必須になります。',
		'freeTextMoreThan500Words': '自由項目は合計500文字以上入力してください。',
		'entryInteger': '整数で入力してください。',
		'requiredProceedId': '選考段階を選択してください。',
		'requiredMemo': '自由項目を入力してください。',
		'entryError': '入力項目にエラーがあります。ご確認下さい。',
		'clientSearchResultIsEmpty': 'お探しの企業は見つかりませんでした。<br />「企業が見つからない場合はこちら」からご登録下さい。',
		'success': '送信しました。',
		'error': 'サーバーエラーが発生しています。'
	},

	clientInfoEntry: {
		'requiredLocalUserEntryClientName': '会社名は必須です。',
		'requiredLocalUserEntryClientUrl': '企業URLは必須です。',
		'urlFormatLocalUserEntryClientUrl': '企業URLが正しくありません。'
	},

	careerMail: {
		'invalidUrl': '不正なURLです',
		'alreadyRecievedStopSendMail': 'メール配信停止は受領済みです。',
		'success': '送信しました。',
		'error': 'サーバーエラーが発生しています。'
	},

	agreementCancel: {
		'clientCommentEmpty': '修正依頼を選択した場合は、修正内容を入力してください。',
		'requiredConformer': '確認者様お名前は必須です。',
		'success': '送信しました。',
		'error': 'サーバーエラーが発生しています。'
	},

	clientNeedsSurvey: {
        'requiredRecruitment' : '■1は必須項目です。',
        'requiredRecruitplan' : '■1で「はい」を選択した時は■2は必須項目です。',
		'requiredRecruitplanEmployment' : '■2は職種と人数を入力してください。',
		'requiredName' : '■4は必須項目です。',
		'success': '送信しました。'
	},

	OrderConfirm: {
		'successOpen': '求人のオープン依頼を受け付けました。<br>ご確認ありがとうございました。',
		'successFix': '求人修正依頼を受け付けました。<br>修正後担当者よりご連絡を致しますので<br>少々お待ちください。',
		'requiredConfirm': '不受理要件に該当しない場合はチェックを入れてください。',
		'requiredProjectScale': '想定されるプロジェクト規模を選択してください。',
		'requiredLastName': '姓を入力してください。',
		'requiredFirstName': '名を入力してください。',
		'requiredComment': 'コメントを入力してください。',
		'errorAllComponent' : '入力エラーになっている項目があります。',
		'confirmClose' : '確認内容が入力されたまま画面を閉じようとしています。入力内容を破棄してよろしいですか？'
	},

	interviewSchedule: {
		'successReschedule': '再調整依頼を受け付けました。',
		'requiredInterviewerName': '面接官の氏名を入力してください。',
		'requiredInterviewDetail': '面接の詳細を入力してください。',
		'errorAllComponent' : '入力エラーになっている項目があります。',
		'confirmSpecifyReshedule': '求職者に再調整を依頼します。<br>面接日時の候補日を提示しますか？',
		'confirmClose' : '入力されている項目があります。<br>画面を閉じてもよろしいですか？',
		'notSelectedDate': '面接候補日を選択してください。'
	},

	// Error with status
	status: {
		'500': 'サーバーエラーが発生しています。',
		'unknown': '不明なエラー'
	},

	// Message for config file
	config: {
		'error': 'サーバーエラーが発生しています。'
	}



}

Vue.use({
	install(Vue, options) {
		Vue.prototype['$message'] = message
	}
})

export default message


// WEBPACK FOOTER //
// ./src/services/message.js